import React, { useEffect, useMemo, useRef, useState, StrictMode, useCallback } from 'react';
import { Grid, Checkbox, FormGroup, FormControlLabel, Chip, Paper, FormControl, FormLabel, TextField, Button, IconButton, MenuItem, Stack, Box, Divider } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';

import { createRoot } from 'react-dom/client';


import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import _, { omit, pick, set } from 'lodash'
import PF from "../_Services/publicFunction";
import { useSnackbar } from "notistack";
import Qs from "qs";
import { DatePicker, Space, Input } from 'antd';
import moment from 'moment';
import { and } from 'ramda';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Autocomplete from '@mui/material/Autocomplete';
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MenuModule } from "@ag-grid-enterprise/menu";
import XLSX from 'xlsx';
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ExcelExportModule,
    MenuModule,
]);

const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
};
const App = props => {
    const { RangePicker } = DatePicker;
    const [ProjectList, setProjectList] = React.useState([]);
    const initialRun = useRef(false);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [pinnedTopRowData, setPinnedTopRowData] = useState([]);
    const rowHeight = 30;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const gridRef = React.useRef();
    const [rowData, setRowData] = useState();

    useEffect(() => {
        if (!initialRun.current) {
            PF.instance({
                method: "post",
                url: PF.url2 + "/CheckProject/GetData",
                data: Qs.stringify({ Action: "1", parameter: { projectName: "" } }),
            })
                .then(function (response) {
                    // alert("完成")
                    const { TotalRecord, rows } = response.data;
                    // console.log(rows)
                    if (TotalRecord > 0) {
                        // enqueueSnackbar("查詢成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        setProjectList(rows)
                    }
                    else {
                        enqueueSnackbar("查無資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                    }
                })

        }
        return () => {
            initialRun.current = true;
        }

    }, [])
    const statusBar = React.useMemo(() => {
        return {
            statusPanels: [
                { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
                // { statusPanel: 'agTotalRowCountComponent', align: 'center' },
                //  { statusPanel: 'agFilteredRowCountComponent' },
                { statusPanel: 'agSelectedRowCountComponent', align: 'right' },
                { statusPanel: 'agAggregationComponent' },
            ],
        };
    }, []);




    const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
    // const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);

    const initialColumnDefs = [
        { field: '身分證號', headerName: "身分證號", width: 130, cellClass: 'default' },
        { field: '姓名', headerName: "姓名", width: 100, cellClass: 'default' },
        { field: '性別', headerName: "性別", width: 70, cellClass: 'default' },
        { field: '生日', headerName: "生日", width: 120, cellClass: 'default' },
        { field: '檢查日', headerName: "檢查日", width: 120, cellClass: 'default' },

    ]
    const [columnDefs, setColumnDefs] = React.useState([
        { field: '身分證號', headerName: "身分證號", width: 130, cellClass: 'default' },
        { field: '姓名', headerName: "姓名", width: 100, cellClass: 'default' },
        { field: '性別', headerName: "性別", width: 70, cellClass: 'default' },
        { field: '生日', headerName: "生日", width: 120, cellClass: 'default' },
        { field: '檢查日', headerName: "檢查日", width: 120, cellClass: 'default' },

    ])
    const dateFormat = 'YYYY/MM/DD'


    const [startDate, setStartDate] = React.useState('')
    const [endDate, setEndDate] = React.useState('')
    const [projectNo, setprojectNo] = React.useState('')
    const [todayList, setTodayList] = React.useState([])
    const [inputValue, setInputValue] = React.useState(''); // 使用 useState 初始化

    const [settingObj, setSettingObj] = useState({
        ProjectNo: {
            value: '', // 初始值
        },
        Name: {
            value: '',
        }
    });

    const handleAutoCompleteChange = (event, newValue) => {
        setSettingObj((prevSettingObj) => ({
            ...prevSettingObj,
            ProjectNo: {
                ...prevSettingObj.ProjectNo,
                value: newValue
            }
        }));
        console.log(newValue)
        // setSettingObj(prevState => ({
        //    ...prevState,
        //     CheckNo: {...prevState.CheckNo,value:newValue.CheckNo}
        // })) 

        // setItemno(newValue.CheckNo)

    };

    const getRows = () => [

        {
            cells: [
                {
                    data: {
                        value: settingObj.ProjectNo.value.ProjectName,
                        type: "String",
                        color: '#0000FF'

                    },
                },
            ],
        },
    ]
    const getParams = () => ({
        prependContent: getRows()
    });

    const onBtExport = useCallback(() => {
        if (todayList.length > 1) {
            gridRef.current.api.exportDataAsExcel(getParams());
        }
        // let blob = gridRef.current.api.getDataAsExcel(getParams());
        // const reader = new FileReader();

        // reader.onload = function (event) {
        //     // 獲取 ArrayBuffer
        //     const data = new Uint8Array(event.target.result);

        //     // 讀取 Excel 數據
        //     const workbook = XLSX.read(data, { type: 'array' });

        //     // 獲取第一個工作表
        //     const firstSheetName = workbook.SheetNames[0];
        //     const worksheet = workbook.Sheets[firstSheetName];

        //     // 將工作表轉換為 JSON 對象
        //     const jsonData = XLSX.utils.sheet_to_json(worksheet);

        //     console.log(jsonData);
        // };

        // // 讀取 Blob 對象
        // reader.readAsArrayBuffer(blob);

    }, [getParams]);

    useEffect(() => {
        console.log(settingObj)
    }, [settingObj])
    const [Rows0, setRows0] = React.useState([])

    const CellErrStyle = Rows0 => props => {
        const { value, data, refreshCell, setValue, column } = props;
        // console.log(props)
        const { 身分證號 } = data;
        const { colId } = column;
        // console.log(colId)
        let Err = Rows0.filter(x => x.ID === 身分證號 && x.ItemName === colId)
        // console.log(Err)
        if (Err[0]?.Err === true) {
            return { color: 'red' }
        } else {
            return { color: 'black' }
        }
    }

    const CellErrStyleExcel = (Rows0) => props => {
        const { value, data, refreshCell, setValue, column } = props;
        // console.log(props)
        const { 身分證號 } = data;
        const { colId } = column;
        // console.log(colId)
        let Err = Rows0.filter(x => x.ID === 身分證號 && x.ItemName === colId)
        // console.log(Err)
        if (Err[0]?.Err === true) {
            return true
        } else {
            return false
        }
    }


    const excelStyles = useMemo(() => {
        return [
            // The base style, red font.
            {
                id: "default",
                interior: {
                    color: "#FFFFFF",
                    pattern: "Solid"
                },
                borders: {
                    borderBottom: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    },
                    borderLeft: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    },
                    borderRight: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    },
                    borderTop: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    }
                }
            },
            {
                id: "header",
                alignment: {
                    vertical: "Center",
                },
                interior: {
                    color: "#f8f8f8",
                    pattern: "Solid",
                    patternColor: undefined,
                },
                font: {
                    color: '#0000FF'
                },
                borders: {
                    borderBottom: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    },
                    borderLeft: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    },
                    borderRight: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    },
                    borderTop: {
                        color: "#000000",
                        lineStyle: "Continuous",
                        weight: 1
                    }
                }
            },
            {
                id: "redFont",
                font: {
                    // fontName: "Calibri Light",
                    // underline: "Single",
                    // italic: true,
                    color: "#FF0000",
                },
            },
            // The cellClassStyle: background is green and font color is light green,
            // note that since this excel style it's defined after redFont
            // it will override the red font color obtained through cellClass:'red'
            // {
            //     id: "greenBackground",
            //     alignment: {
            //         horizontal: 'Right', vertical: 'Bottom'
            //     },
            //     font: { color: "#e0ffc1" },
            //     interior: {
            //         color: "#008000", pattern: 'Solid'
            //     }
            // },
            // {
            //     id: "cell",
            //     alignment: {
            //         vertical: "Center"
            //     }
            // }
        ];
    }, []);
    const handleQuery = () => {
        if (!startDate || startDate === '' || !endDate || endDate === '') {
            enqueueSnackbar('請輸入日期', { variant: 'error', style: { whiteSpace: 'pre-line' }, autoHideDuration: 3000 });
            return;
        }

        if (settingObj.ProjectNo.value === "" || settingObj.ProjectNo.value === null) {
            enqueueSnackbar('請選擇專案', { variant: 'error', style: { whiteSpace: 'pre-line' }, autoHideDuration: 3000 });
            return;
        }
        setOpenBackdrop(true);;
        let no = settingObj.ProjectNo.value.ProjectNo;
        // console.log(no)
        PF.instance({
            method: "post",
            url: PF.url2 + "/CheckProject/GetGeneralForm",
            data: Qs.stringify({
                Action: "Query",
                parameter: {
                    startDate: startDate,
                    endDate: endDate,
                    ProjectNo: no,
                }
            }),
            headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                setOpenBackdrop(false);
                // console.log(response.data)
                const { TotalRecord, Rows0, Rows2, Rows4 } = response.data

                if (TotalRecord < 0) {
                    enqueueSnackbar("錯誤", { variant: "error", style: { whiteSpace: 'pre-line' } });
                } else if (TotalRecord === 0) {
                    enqueueSnackbar("沒有資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                    setTodayList([]);
                    // setHistoryList([]);
                } else {
                    enqueueSnackbar("更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });

                    let rows2 = Rows2.map(item => {

                        return {
                            field: item.ItemName, headerName: item.ItemName, width: 150, cellStyle: CellErrStyle(Rows0)//顯示Grid }
                            , cellClass: 'default'
                            , cellClassRules: { //匯出EXCEL時，會套用到
                                redFont: CellErrStyleExcel(Rows0)
                            }
                        }
                    })
                    console.log(rows2)
                    setColumnDefs([...initialColumnDefs, ...rows2])
                    // setTodayList(Rows4);
                    const [first, ...rest] = Rows4
                    setTodayList(rest);
                    setPinnedTopRowData([first])
                    setRows0(Rows0)
                }
            })
        // } else {
        //     enqueueSnackbar("請輸入日期", { variant: "error", style: { whiteSpace: 'pre-line' } });

        // }


    }

    const handleQueryAll = () => {
        if (!startDate || startDate === '' || !endDate || endDate === '') {
            enqueueSnackbar('請輸入日期', { variant: 'error', style: { whiteSpace: 'pre-line' }, autoHideDuration: 3000 });
            return;
        }

        if (settingObj.ProjectNo.value === "" || settingObj.ProjectNo.value === null) {
            enqueueSnackbar('請選擇專案', { variant: 'error', style: { whiteSpace: 'pre-line' }, autoHideDuration: 3000 });
            return;
        }
        setOpenBackdrop(true);;
        let no = settingObj.ProjectNo.value.ProjectNo;
        // console.log(no)
        PF.instance({
            method: "post",
            url: PF.url2 + "/CheckProject/GetGeneralFormAll",
            data: Qs.stringify({
                Action: "Query",
                parameter: {
                    startDate: startDate,
                    endDate: endDate,
                    ProjectNo: no,
                }
            }),
            headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                setOpenBackdrop(false);
                // console.log(response.data)
                const { TotalRecord, Rows0, Rows2, Rows4 } = response.data

                if (TotalRecord < 0) {
                    enqueueSnackbar("錯誤", { variant: "error", style: { whiteSpace: 'pre-line' } });
                } else if (TotalRecord === 0) {
                    enqueueSnackbar("沒有資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                    setTodayList([]);
                    // setHistoryList([]);
                } else {
                    enqueueSnackbar("更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });

                    let rows2 = Rows2.map(item => {

                        return {
                            field: item.ItemName, headerName: item.ItemName, width: 150, cellStyle: CellErrStyle(Rows0)//顯示Grid }
                            , cellClass: 'default'
                            , cellClassRules: { //匯出EXCEL時，會套用到
                                redFont: CellErrStyleExcel(Rows0)
                            }
                        }
                    })
                    console.log(rows2)
                    setColumnDefs([...initialColumnDefs, ...rows2])
                    // setTodayList(Rows4);
                    const [first, ...rest] = Rows4
                    setTodayList(rest);
                    setPinnedTopRowData([first])
                    setRows0(Rows0)
                }
            })
        // } else {
        //     enqueueSnackbar("請輸入日期", { variant: "error", style: { whiteSpace: 'pre-line' } });

        // }


    }
    const onChange = (date, dateString) => {
        // console.log(dateString);
        setStartDate(dateString[0]);
        setEndDate(dateString[1]);

    };





    // const locales = [
    //     {
    //         language: "en-US",
    //         locale: "en",
    //     },
    //     {
    //         language: "es-ES",
    //         locale: "es",
    //     },
    // ];
    // const [locale, setLocale] = React.useState(locales[0]);
    const popupParent = useMemo(() => {
        return document.body;
    }, []);

    const defaultExcelExportParams = useMemo(() => {
        return {
            fileName: settingObj.ProjectNo?.value?.ProjectName + " 總表.xlsx",
            sheetName: settingObj.ProjectNo?.value?.ProjectName,
            suppressExcelHeader: true,
        };
    }, [settingObj]);

    return (
        <>
            {/* <DatePicker onChange={onChange}  format={dateFormat} />    */}

            {/* <RangePicker onChange={onChange} format={dateFormat} /> */}
            {/* <Input placeholder="Itemno" value={Itemno} onChange={(e) => setItemno(e.target.value)} style={{ width: '80px', marginRight: '5px', marginLeft: '3px' }} /> */}
            <Grid container spacing={2} alignItems="center">
                <Grid item sx={{ marginLeft: '5px' }}>
                    <RangePicker onChange={onChange} format={dateFormat} />
                </Grid>
                <Grid item>
                    <FormControl style={{ marginRight: '8px', marginLeft: '3px', marginTop: '6px', marginBottom: '4px' }}>
                        <Autocomplete
                            value={settingObj.ProjectNo.value || ""}
                            isOptionEqualToValue={(option, value) => option === value}
                            onChange={handleAutoCompleteChange}
                            inputValue={inputValue || ""}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason !== "clear") {
                                    setInputValue(newInputValue);
                                }
                            }}
                            getOptionLabel={(option) => option.ProjectName || ""}
                            filterOptions={(option, { inputValue }) => option.filter(item => item.ProjectNo.toString().includes(inputValue) || item.ProjectName.toString().includes(inputValue))}
                            renderOption={(props, option) => (
                                <li {...props} key={option.ProjectNo}>
                                    {'[' + option.ProjectNo + ']'}
                                    {option.ProjectName}
                                </li>
                            )}
                            options={ProjectList}
                            sx={{ width: 280 }}
                            renderInput={(params) =>
                                <TextField {...params}
                                    size="small"
                                    // error={settingObj.ProjectNo.error || false}
                                    // helperText={settingObj.ProjectNo.error ? settingObj.ProjectNo.helperText : ""}
                                    name={"ProjectNo"}
                                    required={true}
                                    label="專案名稱" variant="outlined" />}
                        />
                    </FormControl>
                </Grid>
                {/* <Grid item>
            <Input placeholder="Value" value={Value} onChange={(e) => setValue(e.target.value)} style={{ width: '480px', height: '43px', marginRight: '3px', marginTop: '3px' }} />
        </Grid> */}
                <Grid item>
                    <Box
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
                    >
                        <Button onClick={handleQuery} variant="contained">勞檢項目</Button>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <Button onClick={handleQueryAll} variant="contained">所有項目</Button>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <Button onClick={onBtExport} variant="contained" color='success'>匯出</Button>
                    </Box>
                </Grid>
                {/* <Grid item sx={{ marginLeft: '200px' }}>
            <Button onClick={handleLogout} variant="contained" startIcon={<ExitToAppIcon />}>登出</Button>
        </Grid> */}
            </Grid>

            <Grid container spacing={0}>
                <Grid item xs={12} md={12} textAlign="right">
                    <div style={containerStyle}>
                        <div className="ag-theme-balham" style={{ height: '92vh', width: '100%' }}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={todayList}
                                columnDefs={columnDefs}
                                rowSelection={'multiple'}
                                defaultColDef={defaultColDef}
                                enableRangeSelection={true}
                                // onRowClicked={handleRowClick}
                                // rowHeight={}
                                enableStatusBar={true}
                                statusBar={statusBar}
                                excelStyles={excelStyles}
                                popupParent={popupParent}
                                defaultExcelExportParams={defaultExcelExportParams}
                                pinnedTopRowData={pinnedTopRowData}
                                // onSelectionChanged={handleSelectionChanged}
                                suppressContextMenu={true}
                            // rowMultiSelectWithClick={true}
                            // onRowDoubleClicked={onRowDoubleClicked}
                            // enableCellTextSelection={true}
                            // ensureDomOrder={true}
                            // groupSelectsFiltered={true}
                            // suppressRowClickSelection={true}
                            >
                            </AgGridReact>
                        </div>
                    </div>
                </Grid>

            </Grid>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openBackdrop}
            // onClick={handleQuery}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>

    )
}

export default App 